export enum Client {
  VXMODELS = 'VXMODELS',
  FEED = 'FEED',
  NOTIFICATIONS = 'NOTIFICATIONS',
}
